import { render, staticRenderFns } from "./HomeNicheIcon.vue?vue&type=template&id=f23ddd9c&scoped=true"
import script from "./HomeNicheIcon.vue?vue&type=script&lang=js"
export * from "./HomeNicheIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23ddd9c",
  null
  
)

export default component.exports